import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'questionizer-core'
import styles from './index.scss?inline'
import './index.scss'

//let configPath = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
import config from "./config.json"

if (config !== undefined) {
  const host = document.getElementById('febis-questionizer');
  if (host){
    // @font-face must be in light DOM — browsers don't load fonts from Shadow DOM stylesheets
    if (!document.getElementById('gc-gruppe-gut-fonts')) {
      const fontStyle = document.createElement('style');
      fontStyle.id = 'gc-gruppe-gut-fonts';
      const fontBase = (config.baseurl || '').replace(/\/+$/, '') + '/fonts/';
      fontStyle.textContent = `
        @font-face { font-display: swap; font-family: 'GUT'; font-style: normal; font-weight: 300; src: url('${fontBase}GUT-Light.woff2') format('woff2'), url('${fontBase}GUT-Light.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GUT'; font-style: normal; font-weight: 400; src: url('${fontBase}GUT-Regular.woff2') format('woff2'), url('${fontBase}GUT-Regular.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GUT'; font-style: normal; font-weight: 500; src: url('${fontBase}GUT-Medium.woff2') format('woff2'), url('${fontBase}GUT-Medium.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GUT'; font-style: normal; font-weight: 700; src: url('${fontBase}GUT-Bold.woff2') format('woff2'), url('${fontBase}GUT-Bold.woff') format('woff'); }
      `;
      document.head.appendChild(fontStyle);
    }

    const shadow = host.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [sheet];

    console.log("ADOPTED",sheet,  shadow.adoptedStyleSheets);

    shadow.appendChild(mountPoint);

      ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <App config={config}/>
      </React.StrictMode>);
    }
  }else{
    console.warn("Keine Konfiguration gefunden");
  }